import React from 'react';
import { Link } from 'react-router-dom';

export function Logo() {
  return (
    <Link to="/" className="flex items-center group">
      <div className="relative overflow-hidden rounded-lg">
        <img
          src="https://www.fixphonespeakers.com/assets/fix-phone-speaker-logo.png"
          alt="Fix Phone Speakers Logo"
          className="h-8 w-auto object-contain transition-transform duration-300 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-blue-500/20 blur-xl opacity-0 group-hover:opacity-100 transition-opacity" />
      </div>
    </Link>
  );
}